export const SET_PERIOD = 'features/WeeklyPeriod/SET_PERIOD'; 
export const NEXT_PERIOD = 'features/WeeklyPeriod/NEXT_PERIOD';
export const PREV_PERIOD = 'features/WeeklyPeriod/PREV_PERIOD';
